import styled from "styled-components";

export const ErrorBoundaryContent = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	row-gap: 10px;
	h2 {
		font-family: 'Suit bold', 'Inter bold';
		font-weight: 800;
		font-size: 60px;
		color: rgba(18, 6, 45, 1);
		margin-bottom: 40px;
	}
	p {
		font-family: 'Suit medium', 'Inter medium';
		font-weight: 600;
		font-size: 20px;
	}
	span {
		font-family: 'Suit regular', 'Inter regular';
		font-weight: 400;
		font-size: 20px;
	}
	
	button {
		font-family: 'Suit medium', 'Inter medium';
		font-weight: 600;
		font-size: 20px;
		background-color:  rgba(18, 6, 45, 1);
		color: white;
		padding: 10px;
		border-radius: 10px;
	}
`;

export const ReservationPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 234px 1fr;
  min-height: 0;
  min-width: 0;
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    grid-template-columns: 100%;
		height: auto;
  }
  @media screen and (min-width: 1000px) and (max-width: 1200px) {
    grid-template-columns: 160px 1fr;
  }
	@media screen and (min-width: 1920px) and (max-width: 2500px) {
    grid-template-columns: 370px 1fr;
  }
	@media screen and (min-width: 2500px) and (max-width: 5000px) {
    grid-template-columns: 420px 1fr;
  }
`;

export const ReservationContent = styled.div`
	width: 100%;
	height: 100%;
  padding: 20px;
	display: grid;
  grid-template-columns: 2.3fr 1fr;
  grid-column-gap: 20px;
  box-sizing: border-box;
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    padding: 10px;
  }
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    grid-template-columns: 2.3fr 1fr;
  }
  @media screen and (min-width: 300px) and (max-width: 1010px) {
    grid-template-columns: 100%;
  }
  `;
  
export const NotSiteContent = styled.div`
  display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
  padding: 20px;
  box-sizing: border-box;
	h1 {
		font-family: 'Suit extra bold', 'Inter bold';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 25px;
	}
  span {
    width: 100%;
    height: 100%;
    border: 1px solid rgba(202, 201, 204, 1);
    background-color: rgba(238, 237, 240, 1);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    row-gap: 20px;
  }
  img {
    width: 67px;
    height: 67px;
  }
  p {
    font-family: 'Suit medium', 'Inter medium';
    color: rgba(151, 151, 153, 1);
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
  }
  @media screen and (min-width: 1920px) and (max-width: 5000px) {
    h1 {
      font-size: 24px;
      line-height: 28px;
    }
    img {
      width: 85px;
      height: 85px;
    }
    p {
      font-size: 26spx;
    }
  }
`

